import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { userService } from '../../../shared/api/services/users.service'

export const useUsers = () => {
    const [searchText, setSearchText] = useState('')
    const [statusFilter, setStatusFilter] = useState<string>('all')
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)

    // Fetch users from API
    const { data: response, isLoading, isFetching, error, refetch } = useQuery({
        queryKey: ['users', page, pageSize, searchText, statusFilter],
        queryFn: () => userService.getUsers({
            page,
            per_page: pageSize,
            role: 'customer',
            search: searchText || undefined,
            status: statusFilter !== 'all' ? statusFilter : undefined
        }),
        placeholderData: (previousData) => previousData,
    })

    const users = response?.data || []
    const totalUsers = response?.meta?.total || 0

    return {
        users, // Return API data directly, filtering is handled by API
        searchText,
        setSearchText,
        statusFilter,
        setStatusFilter,
        totalUsers,
        page,
        setPage,
        pageSize,
        setPageSize,
        isLoading,
        isFetching,
        error,
        refetch,
    }
}
